import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Word} from '../../dtos/vocab/entry/word';
import {Injectable} from '@angular/core';
import {Globals} from '../../global/globals';
import {WordPage} from '../../dtos/vocab/entry/word-page';
import {Article} from '../../shared/Article';
import {FormOptionsLists} from '../../shared/FormOptionsLists';
import {VocabEntryCreationDto} from "../../dtos/vocab/entry/vocab-entry-creation-dto";
import {SharedService} from "../common/shared.service";

@Injectable({
  providedIn: 'root'
})

export class WordService {

  // filter options
  formOptionsLists = new FormOptionsLists();

  private wordsBaseUri: string = this.globals.backendUri + '/vocabulary/entries';
  private vocabExportUri: string = this.globals.backendUri + '/exports/vocabulary';

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  searchEntries(params: HttpParams): Observable<any> { // any necessary for service injection into child component
    return this.httpClient.get<WordPage>(this.wordsBaseUri, {params});
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<any>(this.wordsBaseUri + '/' + id);
  }

  createWord(word: VocabEntryCreationDto): Observable<Word> {
    return this.httpClient.post<Word>(this.wordsBaseUri, word);
  }

  updateWord(word: VocabEntryCreationDto, id: number): Observable<Word> {
    return this.httpClient.put<Word>(this.wordsBaseUri + '/' + id, word);
  }

  exportAll(): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(this.vocabExportUri, {observe: 'response', responseType: 'blob'});
  }

  /**
   * Loads specific word from the backend
   *
   * @param id of word to load
   */
  getEntry(id: number): Observable<any> { // any necessary for service injection into child component
    return this.httpClient.get<Word>(this.wordsBaseUri + '/' + id);
  }

  getEntryAsArray(word: Word) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(this.sharedService.extractReferences(word))
    const entries = [];
    for (const tmpEntry of tmpEntries) {
      if (tmpEntry[0] !== 'id' && tmpEntry[0] !== 'name') {
        if (tmpEntry[0] === 'vocabType') {
          tmpEntry[0] = 'Wortart';
          tmpEntry[1] = this.formOptionsLists.typeToString.get(tmpEntry[1]);
        } else if (tmpEntry[0] === 'receptive') {
          tmpEntry[0] = 'Niveau (rez.)';
        } else if (tmpEntry[0] === 'productive') {
          tmpEntry[0] = 'Niveau (prod.)';
        } else if (tmpEntry[0] === 'article') {
          tmpEntry[0] = 'Artikel';
          tmpEntry[1] = this.getArticleDetails(tmpEntry[1]);
        } else if (tmpEntry[0] === 'category') {
          tmpEntry[0] = 'Themenbaum';
          tmpEntry[1] = this.sharedService.getCategoryTree(tmpEntry[1]);
        } else if (tmpEntry[0] === 'plural') {
          tmpEntry[0] = 'Plural';
        } else if (tmpEntry[0] === 'present') {
          tmpEntry[0] = 'Präsens';
        } else if (tmpEntry[0] === 'simplePast') {
          tmpEntry[0] = 'Präteritum';
        } else if (tmpEntry[0] === 'pastParticiple') {
          tmpEntry[0] = 'Partizip Perfekt';
        } else if (tmpEntry[0] === 'comment') {
          tmpEntry[0] = 'Kommentar';
          if (Array.isArray(tmpEntry[1])) {
            tmpEntry[1] = tmpEntry[1].join(', ');
          } else {
            continue;
          }
        } else if (tmpEntry[0] === 'isSingular') {
          tmpEntry[0] = 'Singular / Plural';
          if (tmpEntry[1]) {
            tmpEntry[1] = 'nur Singular';
          } else {
            tmpEntry[1] = 'nur Plural';
          }
        } else if (tmpEntry[0] === 'country') {
          tmpEntry[0] = 'Variante';
          tmpEntry[1] = this.formOptionsLists.countryToString.get(tmpEntry[1]);
        } else if (tmpEntry[0] === 'examples') {
          if (tmpEntry[1][0]) {
            tmpEntry[0] = 'Beispiele';
          } else {
            continue;
          }
        } else if (tmpEntry[0] === 'test') {
          tmpEntry[0] = 'Test';
        } else if (tmpEntry[0] === 'relatedVocab') {
          tmpEntry[0] = 'Bezugswort';
          if (tmpEntry[1].length > 0) {
            tmpEntry[1] = tmpEntry[1].map(_ => _.name).join(', ');
          } else {
            continue;
          }
        }
        entries.push(tmpEntry);
      }
    }
    return entries;

  }


  /**
   * checks if the value is a Article and returns the given string value of Article
   *
   * @param value a Article element
   */
  private getArticleDetails(value: string): string | undefined {
    const v = String(value) in Article ? Article[String(value)] : undefined;
    if (v === undefined) {
      return v;
    } else {
      switch (v) {
        case 'derdie':
          return 'der / die';
        case 'derdas':
          return 'der / das';
        case 'diedas':
          return 'die / das';
        default:
          return v;
      }
    }
  }

}
